import React from 'react';

import LinkTextComponent from '../linkTextComponent/linkTextComponent';
import PillComponent from '../../pillComponent/pillComponent';
import QuestionWithTooltipComponent from '../questionWithTooltipComponent/questionWithTooltipComponent';

import './subTitleComponentV2.css';

const SubTitleComponentV2 = ({
  linkTxt = 'Read more.',
  linkUrl = '',
  pillType = null,
  subTitleTxt,
  subToolTipTxt = null,
  subToolTipPosition = 'right',
}) => {
  return (
    <div className="et-v2-sub-title-component-container">
      <div className="et-v2-sub-title-text-wrap">
        {subTitleTxt}
        {linkUrl && <LinkTextComponent linkTxt={linkTxt} linkUrl={linkUrl} />}
      </div>
      {pillType && <PillComponent pillType={pillType} />}
      {subToolTipTxt && (
        <div className="et-v2-sub-title-tooltip-wrap">
          <>
            <div className="et-n-input-title-tooltip-upgrade-btn-separator" />
            <QuestionWithTooltipComponent
              toolTipPosition={subToolTipPosition}
              toolTipTxt={subToolTipTxt}
            />
          </>
        </div>
      )}
    </div>
  );
};

export default SubTitleComponentV2;
